import { render, staticRenderFns } from "./WholeSaleDiscount.vue?vue&type=template&id=4c135c82&lang=pug&"
import script from "./WholeSaleDiscount.vue?vue&type=script&lang=js&"
export * from "./WholeSaleDiscount.vue?vue&type=script&lang=js&"
import style0 from "./WholeSaleDiscount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WholeSaleDiscount.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {
  VRadio,
  VRadioGroup,
})
